import type { BimWorkOrderPriceData, BimWorkOrderVersionPriceData } from 'gql/graphql';

export const getWhereVariables = (filterValues?: Record<string, string[]>) => {
    if (!filterValues) {
        return undefined;
    }

    return {
        and: Object.entries(filterValues).reduce((acc: any, [key, value]) => {
            if (key === 'object' && value.length) {
                acc = [
                    ...acc,
                    {
                        or: [{ [key]: { name: { in: value } } }],
                    },
                ];
            }

            if ((key === 'code' || key === 'name') && value.length) {
                acc = [
                    ...acc,
                    {
                        or: [{ planValue: { [key]: { in: value } } }],
                    },
                ];
            }

            return acc;
        }, []),
    };
};

export type ExtendedBimWorkOrderPriceData = BimWorkOrderPriceData & { code: number };
export type ExtendedBimWorkOrderPriceVersionData = BimWorkOrderVersionPriceData & { code: number };

export const prepareCodeToSort = (code: string): number => {
    const numberCodeValue = code.replace(/\D/g, '');

    if (numberCodeValue.length > 8) {
        return Number(numberCodeValue.slice(0, -1));
    }

    return Number(numberCodeValue);
};
